import {
  User,
  UserManager,
  WebStorageStateStore,
  type UserManagerSettings,
} from 'oidc-client-ts';
import type { AppConfig } from '@/config/runtime-config';

interface SigninState {
  returnPath?: string;
}

let cachedManager: UserManager | null = null;
let cachedKey: string | null = null;

function getOidcSettings(config: AppConfig): UserManagerSettings {
  return {
    authority: config.oidcAuthority,
    client_id: config.oidcClientId,
    redirect_uri: config.redirectUri,
    post_logout_redirect_uri: config.postLogoutRedirectUri,
    silent_redirect_uri: config.oidcSilentRedirectUri,
    response_type: 'code',
    scope: config.oidcScope,
    automaticSilentRenew: true,
    loadUserInfo: true,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
  };
}

export function getOidcManager(config: AppConfig): UserManager {
  const key = JSON.stringify({
    authority: config.oidcAuthority,
    clientId: config.oidcClientId,
    redirectUri: config.redirectUri,
    postLogoutRedirectUri: config.postLogoutRedirectUri,
    silentRedirectUri: config.oidcSilentRedirectUri,
    scope: config.oidcScope,
  });

  if (!cachedManager || cachedKey !== key) {
    cachedManager = new UserManager(getOidcSettings(config));
    cachedKey = key;
  }

  return cachedManager;
}

export async function getStoredOidcUser(config: AppConfig): Promise<User | null> {
  return getOidcManager(config).getUser();
}

export async function handleOidcSigninCallback(config: AppConfig): Promise<string> {
  const user = await getOidcManager(config).signinRedirectCallback();
  const state = (user.state ?? {}) as SigninState;
  return state.returnPath || '/dashboard';
}

export async function handleOidcSilentCallback(config: AppConfig): Promise<void> {
  await getOidcManager(config).signinSilentCallback();
}